import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white">
      <h1 className="text-3xl font-bold mb-6" style={{color: 'rgba(0, 0, 0, 0.95)'}}>
        Política de Privacidad
      </h1>
      
      <div className="space-y-6 text-base" style={{color: 'rgba(0, 0, 0, 0.95)'}}>
        <section>
          <h2 className="text-xl font-semibold mb-3">1. Información que Recopilamos</h2>
          <p>
            Para brindar nuestros servicios de nutrición, recopilamos la siguiente información:
          </p>
          <ul className="list-disc pl-6 mt-2 space-y-2">
            <li>Información personal: nombre, edad, correo electrónico, número de teléfono</li>
            <li>Información de salud: historial médico, medidas antropométricas, hábitos alimenticios</li>
            <li>Información de pago: datos necesarios para procesar compras de planes y productos</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">2. Uso de la Información</h2>
          <p>Utilizamos su información para:</p>
          <ul className="list-disc pl-6 mt-2 space-y-2">
            <li>Diseñar planes nutricionales personalizados</li>
            <li>Realizar seguimiento de su progreso</li>
            <li>Procesar pedidos de suplementos y e-books</li>
            <li>Enviar información relevante sobre nutrición y bienestar</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">3. Protección de Datos</h2>
          <p>
            Como profesional colegiada en Perú, cumplimos con todas las regulaciones de protección de datos
            establecidas por la Ley N° 29733 - Ley de Protección de Datos Personales.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">4. Compartir Información</h2>
          <p>
            No compartimos su información personal con terceros, excepto cuando sea necesario para:
          </p>
          <ul className="list-disc pl-6 mt-2 space-y-2">
            <li>Procesar pagos seguros</li>
            <li>Cumplir con requisitos legales</li>
            <li>Proteger nuestros derechos o propiedad</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">5. Sus Derechos</h2>
          <p>
            Usted tiene derecho a acceder, corregir o solicitar la eliminación de su información personal
            en cualquier momento.
          </p>
        </section>
      </div>
    </div>
  );
};

const TermsAndConditions = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white">
      <h1 className="text-3xl font-bold mb-6" style={{color: 'rgba(0, 0, 0, 0.95)'}}>
        Términos y Condiciones
      </h1>
      
      <div className="space-y-6 text-base" style={{color: 'rgba(0, 0, 0, 0.95)'}}>
        <section>
          <h2 className="text-xl font-semibold mb-3">1. Servicios Ofrecidos</h2>
          <p>
            Ofrecemos servicios de asesoría nutricional, venta de planes nutricionales personalizados,
            suplementos nutricionales y recursos educativos (e-books).
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">2. Responsabilidad Profesional</h2>
          <p>
            Como nutricionista colegiada en Perú, todos los servicios se brindan bajo los estándares
            profesionales y éticos establecidos por el Colegio de Nutricionistas del Perú.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">3. Productos y Pagos</h2>
          <ul className="list-disc pl-6 mt-2 space-y-2">
            <li>Los precios de los servicios y productos están en Soles Peruanos (PEN)</li>
            <li>Los e-books y planes digitales se enviarán dentro de las 24 horas posteriores a la confirmación del pago</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">4. Política de Reembolsos</h2>
          <p>
            Los planes nutricionales personalizados y consultas realizadas no son reembolsables.
            Para productos físicos (suplementos), no se aceptan devoluciones.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">5. Propiedad Intelectual</h2>
          <p>
            Todos los materiales, incluyendo e-books, planes nutricionales y contenido educativo,
            están protegidos por derechos de autor y no pueden ser reproducidos sin autorización.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">6. Exención de Responsabilidad</h2>
          <p>
            Los resultados pueden variar entre individuos. Los planes nutricionales son recomendaciones
            profesionales, pero no reemplazan la atención médica. Consulte con su médico antes de
            iniciar cualquier plan nutricional o consumir suplementos.
          </p>
        </section>
      </div>
    </div>
  );
};

export { PrivacyPolicy, TermsAndConditions };